import React from 'react';
import { ContactFieldManager, FMGModal, Form } from 'components';
import { ContactInfoCardDataType } from 'typings/form';
import { useContactInfoEdit } from './useContactInfoEdit';

export interface IContactInfoEdit {
  modalState: boolean;
  onModalStateChange: () => void;
  dataToEdit: ContactInfoCardDataType[];
}

export const ContactInfoEdit = (props: IContactInfoEdit) => {
  const { modalState, onModalStateChange, dataToEdit } = props;
  const { onContactInfoUpdate, onCancel, onValuesChange, contextHolder, isLoading, form, disableSaveBtn } =
    useContactInfoEdit({
      onModalStateChange,
      modalState,
    });
  return (
    <>
      {contextHolder}
      <FMGModal
        open={modalState}
        title={'Update Contact Info'}
        okText={'Save'}
        width={680}
        isLoading={isLoading}
        disableOkBtn={disableSaveBtn}
        onCancel={onCancel}
        onSubmit={onContactInfoUpdate}
      >
        <Form
          layout={'vertical'}
          requiredMark={false}
          form={form}
          className={'margin-t-20'}
          onValuesChange={onValuesChange}
        >
          <ContactFieldManager modalState={modalState} dataToEdit={dataToEdit} form={form} />
        </Form>
      </FMGModal>
    </>
  );
};
